// extracted by mini-css-extract-plugin
module.exports = {"fatalErrorMessage":"J2xxjG"};